import { render, staticRenderFns } from "./PlanDetails.vue?vue&type=template&id=66e18c46&"
import script from "./PlanDetails.vue?vue&type=script&lang=js&"
export * from "./PlanDetails.vue?vue&type=script&lang=js&"
import style0 from "./PlanDetails.vue?vue&type=style&index=0&id=66e18c46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QItemLabel,QIcon,QTooltip,QInput,QPopupProxy,QDate,QSelect,QBtn,QInnerLoading,QField,QItem} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QItemLabel,QIcon,QTooltip,QInput,QPopupProxy,QDate,QSelect,QBtn,QInnerLoading,QField,QItem})
